import { ReactNode, SyntheticEvent } from 'react';
import { TabsWrapper } from './styles';

type TabsType = {
  onChange: (value: string, event?: SyntheticEvent<EventTarget>) => void;
  children: ReactNode;
};

export const Tabs = ({ onChange, children }: TabsType) => {
  const changeTabsHandler = (event: SyntheticEvent<EventTarget>) => {
    const tab = (event.target as HTMLElement).closest<HTMLElement>('[data-value]');

    if (!tab) return;

    const value = (event.target as HTMLDivElement).dataset.value;

    onChange(value, event);
  };

  return <TabsWrapper onClick={(event) => changeTabsHandler(event)}>{children}</TabsWrapper>;
};
